<h4 class="font-weight-bolder health_header powertrain_headers">
  12 Hour Health Status & Alarms
</h4>
<div class="health_bar_chart">
  <div
    *ngIf="stackvelocitychartLoader && stackvelocitychartErr == ''"
    class="skeleton skeleton-text w_90"
  ></div>
  <div
    *ngIf="!stackvelocitychartLoader && stackvelocitychartErr != ''"
    class="health_bar_err"
  >
    {{ stackvelocitychartErr }}
  </div>
  <div
    id="stackvelocitychartContainer"
    style="height: 100px; width: 100%; display: block"
  ></div>
</div>
